import {
  AudioOptions,
  TemplateOptions,
  VideoOptions,
} from '../../app/Shared/constants';
import {
  HomeRoutes,
  MediaTypesRoutes,
  MemberMediaTypesRoutes,
  SiteEnum,
} from './enums';

export const COLLECTIONS = 'Collections';

export const getTopLevelOptions = (isLoggedIn: boolean) => {
  return [
    {
      label: 'Video',
      site: SiteEnum.Videoblocks,
      url: HomeRoutes.Videoblocks,
      options: [
        {
          label: VideoOptions.STOCK_FOOTAGE,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.VideoFootage
            : MediaTypesRoutes.VideoFootage,
        },
        {
          label: VideoOptions.BACKGROUNDS,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.VideoMotionBackgrounds
            : MediaTypesRoutes.VideoMotionBackgrounds,
        },
      ],
    },
    {
      label: 'Templates',
      site: SiteEnum.Videoblocks,
      url: isLoggedIn
        ? MemberMediaTypesRoutes.Templates
        : MediaTypesRoutes.VideoTemplates,
      options: [
        {
          label: TemplateOptions.AFTER_EFFECTS,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.TemplateAfterEffects
            : MediaTypesRoutes.TemplateAfterEffects,
        },
        {
          label: TemplateOptions.PREMIERE_PRO,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.TemplatePremierePro
            : MediaTypesRoutes.TemplatePremierePro,
        },
        {
          label: TemplateOptions.DAVINCI_RESOLVE,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.TemplateDaVinciResolve
            : MediaTypesRoutes.TemplateDaVinciResolve,
        },
        {
          label: TemplateOptions.APPLE_MOTION,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.TemplateAppleMotion
            : MediaTypesRoutes.TemplateAppleMotion,
        },
      ],
    },
    {
      label: 'Audio',
      site: SiteEnum.Audioblocks,
      url: HomeRoutes.Audioblocks,
      options: [
        {
          label: AudioOptions.MUSIC,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.AudioMusic
            : MediaTypesRoutes.AudioMusic,
        },
        {
          label: AudioOptions.EFFECTS,
          url: isLoggedIn
            ? MemberMediaTypesRoutes.AudioSfx
            : MediaTypesRoutes.AudioSfx,
        },
      ],
    },
    {
      label: 'Images',
      site: SiteEnum.Graphicstock,
      url: HomeRoutes.Graphicstock,
    },
    {
      label: COLLECTIONS,
    },
  ];
};
